module.exports = __webpack_public_path__ + "static/media/set-genie-download-mobile-top.eb444ecd.jpg";